var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconAmenitityExtra = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.39 7.808a3.878 3.878 0 0 0-3.882-3.875 3.878 3.878 0 0 0-3.883 3.875 3.878 3.878 0 0 0 3.883 3.874 3.878 3.878 0 0 0 3.882-3.874zm1.796 1.291a5.822 5.822 0 0 1-5.678 4.52c-3.216 0-5.824-2.602-5.824-5.811s2.608-5.812 5.824-5.812a5.822 5.822 0 0 1 5.678 4.52h2.903a1.945 1.945 0 0 1 1.448-.645h4.206a1.94 1.94 0 0 1 1.941 1.937 1.94 1.94 0 0 1-1.941 1.937h-4.206c-.574 0-1.092-.25-1.448-.646h-2.903zM8.508 5.225a2.586 2.586 0 0 1 2.588 2.583 2.586 2.586 0 0 1-2.588 2.583 2.586 2.586 0 0 1-2.589-2.583 2.586 2.586 0 0 1 2.589-2.583zm10.353 6.457c.537 0 .97.432.97.97v.322h3.882c.538 0 .971.432.971.969a.967.967 0 0 1-.97.968h-9.706a.967.967 0 0 1-.971-.968c0-.537.433-.969.97-.969h3.883v-.323c0-.537.433-.969.97-.969zm-4.53 9.041v-4.52h9.059v4.52a1.94 1.94 0 0 1-1.941 1.937h-5.177a1.94 1.94 0 0 1-1.94-1.937zm-9.706-5.812h5.177a1.94 1.94 0 0 1 1.94 1.938 1.94 1.94 0 0 1-1.94 1.937h-.647c0 .714-.579 1.291-1.294 1.291H5.272a1.291 1.291 0 0 1-1.294-1.291v-3.229c0-.355.291-.646.647-.646zm5.177 2.583c.356 0 .647-.29.647-.645a.648.648 0 0 0-.647-.646h-.647v1.291h.647zm-6.147 3.23h7.117a.967.967 0 1 1 0 1.937H3.655a.967.967 0 0 1-.971-.97c0-.536.433-.968.97-.968z",
    fill: "#1A202C",
    fillRule: "nonzero"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconAmenitityExtra, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-amenitity-extra.56900715.svg";
export { ForwardRef as ReactComponent };